import axios from 'axios';
import { API_URL, MAX_RETRY } from '../config';
import { NetworkError } from '../errors';
import { useMerchantStore } from '../stores/merchants';
import { delay } from '../utils/time.utils';

axios.defaults.withCredentials = true;

export const createLayupClient = (retry: boolean = true, withCredentials: boolean = true) => {
  let retryCount = 1;
  const client = axios.create({
    baseURL: API_URL,
    withCredentials,
    timeout: 10000,
    headers: {
      'Access-Control-Allow-Headers': 'Set-Cookie',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  });

  client.interceptors.request.use((config) => {
    const merchantStore = useMerchantStore();
    if (merchantStore.activeMerchantId) {
      config.headers['merchant-id'] = merchantStore.activeMerchantId;
    }

    return config;
  });

  client.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED' || error.code === 'ERR_CONNECTION_REFUSED') {
        if (retry && retryCount <= MAX_RETRY) {
          retryCount += 1;
          await delay(1000);
          return client(error.config);
        } else {
          return Promise.reject(new NetworkError(error.message));
        }
      }
      return Promise.reject(error);
    },
  );
  return client;
};
